module.exports = __webpack_public_path__ + "static/media/tlyfe_logo_white.5b1b93f3.png";